import {
  Home,
  About,
  Auth,
  Marketing,
  RefundRequestor,
  RefundApprover,
  RefundManager,
  RefundExplorer,
  RefundViewer,
  Welcome,
  RefundCompletedExplorer,
  AdminSettings,
  ServiceManager,
  DnsManager,
  DnsSearch
} from './containers';

export default [
  {
    exact: true,
    path: "/",
    component: Welcome,
    authenticate: true
  }, {
    exact: true,
    path: "/bd",
    component: Home,
    authenticate: true,
    roles: ['SU', 'MGMT', 'BD', 'TECH']
  }, {
    exact: true,
    path: "/about-us",
    component: About
  }, {
    exact: true,
    path: "/auth",
    component: Auth
  }, {
    exact: true,
    path: "/marketing",
    component: Marketing,
    authenticate: true,
    roles: ['SU', 'MGMT', 'OPT', 'TECH']
  }, {
    exact: true,
    path: '/refund-requestor',
    component: RefundRequestor,
    authenticate: true,
    roles: ['SU', 'MGMT', 'CC_LEVEL_1', 'CC_LEVEL_1_US', 'CC_LEVEL_1_AE']
  }, {
    exact: true,
    path: '/refund-approver',
    component: RefundApprover,
    authenticate: true,
    roles: ['SU', 'MGMT', 'CC_APPROVER', 'CC_APPROVER_US', 'CC_APPROVER_AE']
  }, {
    exact: true,
    path: '/refund-manager',
    component: RefundManager,
    authenticate: true,
    roles: ['SU', 'MGMT', 'CC_MANAGER', 'CC_MANAGER_US', 'CC_MANAGER_AE']
  }, {
    exact: true,
    path: '/refund-explorer',
    component: RefundExplorer,
    authenticate: true,
    roles: ['SU', 'MGMT', 'CC_MANAGER', 'CC_MANAGER_US', 'CC_MANAGER_AE', 'CC_LEVEL_1', 'CC_LEVEL_1_US', 'CC_LEVEL_1_AE']
  }, {
    exact: true,
    path: '/refund-completed',
    component: RefundCompletedExplorer,
    authenticate: true,
    roles: ['SU', 'MGMT', 'CC_LEVEL_1', 'CC_LEVEL_1_US', 'CC_LEVEL_1_AE', 'CC_MANAGER_AE']
  }, {
    exact: true,
    path: '/admin-settings',
    component: AdminSettings,
    authenticate: true,
    roles: ['SU']
  }, {
    exact: true,
    path: '/refund/:id',
    component: RefundViewer,
    authenticate: true,
    roles: [
      'SU', 'MGMT', 'CC_LEVEL_1',
      'CC_LEVEL_1_US', 'CC_LEVEL_1_AE', 'CC_MANAGER',
      'CC_MANAGER_US', 'CC_MANAGER_AE', 'CC_APPROVER',
      'CC_APPROVER_US', 'CC_APPROVER_AE'
    ]
  }, {
    exact: true,
    path: '/service-manager',
    component: ServiceManager,
    authenticate: true,
    roles: [
      'SU', 'TECH'
    ]
  }, {
    exact: true,
    path: '/domains',
    component: DnsManager,
    authenticate: true,
    roles: ['SU', 'DNS_MANAGER']
  }, {
    exact: true,
    path: '/domains/:domain',
    component: DnsManager,
    authenticate: true,
    roles: ['SU', 'DNS_MANAGER']
  }, {
    exact: true,
    path: '/search',
    component: DnsSearch,
    authenticate: true,
    roles: ['SU', 'DNS_MANAGER']
  }
];



// WEBPACK FOOTER //
// ./src/routes.js